import { useState, useEffect } from 'react';

function getNextThreshold(value: number) {
  const thresholds = [480, 650, 720, 850, 1200, 1920];
  for (let i = 0; i < thresholds.length; i++) {
    if (value <= thresholds[i]) {
      return thresholds[i];
    }
  }
  return 480;
}

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  const range: number = getNextThreshold(width);
  return {
    width,
    height,
    range,
  };
}

export default function useWindowDimensions() {
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  return windowDimensions;
}
